/* @flow */
import ChatSettingsConstants from 'settings/constants/ChatSettingsConstants';
import Entity from 'lib/Entity';

class OfficeHoursDay extends Entity {
  getDay() {
    return this.get('day');
  }

  getStartTime() {
    return this.get('start_time');
  }

  getEndTime() {
    return this.get('end_time');
  }

  static create(day, startTime, endTime) {
    return new OfficeHoursDay({
      day,
      start_time: startTime || ChatSettingsConstants.OfficeHours.START_TIME_DEFAULT,
      end_time: endTime || ChatSettingsConstants.OfficeHours.END_TIME_DEFAULT,
    });
  }
}

export default OfficeHoursDay;



// WEBPACK FOOTER //
// ./src/entities/OfficeHoursDay.js